import type { ReactNode } from "react";

type Band = "pass" | "warn" | "fail";

export interface FeedbackBubbleProps {
  band: Band;
  bandLabel: string;
  total: number;
  max: number;
  tutorParagraph: string;
  tutorParagraphTranslation?: string | null;
  criteria: Array<{ key: string; label: string; value: number; max: number }>;
  extras?: ReactNode | null;
}

const BAND_COLOR: Record<Band, string> = {
  pass: "var(--pass)",
  warn: "var(--warn)",
  fail: "var(--fail)",
};

export function FeedbackBubble(p: FeedbackBubbleProps) {
  return (
    <article className="rounded-xl border border-[var(--border)] bg-[var(--panel)] p-5 space-y-4">
      <div className="flex items-center gap-3">
        <span
          className="inline-block w-2 h-2 rounded-full"
          style={{ background: BAND_COLOR[p.band] }}
        />
        <span className="font-mono-badge text-xs uppercase tracking-wider text-[var(--ink-faint)]">
          BEOORDELING
        </span>
        <span className="text-sm font-semibold text-[var(--ink)]">{p.bandLabel}</span>
        <span className="ml-auto font-mono-badge text-sm text-[var(--ink-muted)]">
          {p.total}/{p.max}
        </span>
      </div>
      <p className="font-serif-italic text-[var(--ink)] leading-relaxed">{p.tutorParagraph}</p>
      {p.tutorParagraphTranslation ? (
        <p className="text-sm text-[var(--ink-muted)] leading-relaxed">
          {p.tutorParagraphTranslation}
        </p>
      ) : null}
      {p.criteria.length > 0 ? (
        <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {p.criteria.map((c) => (
            <li
              key={c.key}
              className="rounded-md border border-[var(--border)] bg-[var(--panel-soft)] px-3 py-2 flex items-center justify-between"
            >
              <span className="text-xs text-[var(--ink-muted)]">{c.label}</span>
              <span className="font-mono-badge text-xs text-[var(--ink)]">
                {c.value}/{c.max}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      {p.extras ?? null}
    </article>
  );
}
